import LTR from "@brand-icons/global/package-time/package-time-ltr.svg";
import RTL from "@brand-icons/global/package-time/package-time-rtl.svg";

import { iconFactory } from "../iconFactory";

export const PackageTimeIcon = iconFactory("PackageTimeIcon", LTR, RTL);
